import React from 'react';
import { ThumbFrame, INK } from './thumbFrame';

/** Enterprise-grade website security — A+ shield with a protection pulse. */
const SecurityThumb: React.FC = () => (
  <ThumbFrame label="Website Security — A+ hardened">
    {/* Protection pulse rings */}
    <circle cx="168" cy="158" r="70" fill="none" stroke={INK} strokeWidth="1.5" opacity="0">
      <animate attributeName="r" values="60;120" dur="3s" repeatCount="indefinite" />
      <animate attributeName="opacity" values="0.35;0" dur="3s" repeatCount="indefinite" />
    </circle>

    {/* Shield */}
    <path d="M168 62 L244 92 L244 166 Q244 216 168 246 Q92 216 92 166 L92 92 Z" fill={INK} opacity="0.04" />
    <path d="M168 62 L244 92 L244 166 Q244 216 168 246 Q92 216 92 166 L92 92 Z" fill="none" stroke={INK} strokeWidth="2" />

    {/* Checkmark */}
    <path d="M138 158 l20 22 l42 -50" fill="none" stroke={INK} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />

    {/* A+ score badge */}
    <circle cx="300" cy="88" r="30" fill="#ffffff" stroke={INK} strokeWidth="1.8" />
    <text x="300" y="96" textAnchor="middle" fontFamily="'Instrument Serif', Georgia, serif" fontSize="26" fill={INK}>A+</text>
    <circle cx="300" cy="88" r="30" fill="none" stroke={INK} strokeWidth="1.8" opacity="0">
      <animate attributeName="r" values="30;40" dur="2.6s" repeatCount="indefinite" />
      <animate attributeName="opacity" values="0.5;0" dur="2.6s" repeatCount="indefinite" />
    </circle>
  </ThumbFrame>
);

export default SecurityThumb;
